import { createAction, props } from '@ngrx/store';

export const saveSubscriptionOutOfStock = createAction(
              '[Items] saveProductsSubscription',
              props<{item:any}>()
)

export const saveSubscriptionOutOfStockBraze = createAction(
  '[Items Braze] saveProductsSubscriptionBraze',
  props<{items: any[]}>()
)

export const modalSubscriptionOutOfStockBraze = createAction(
  '[Open Modal] modalSubscriptionBraze',
  props<{show: boolean}>()
)

export const removeSubscriptionOutOfStock = createAction(
  '[Items] removeProductsSubscription',
  props<{ item: string }>(),
);
